import { string, object } from '@gogame/schemas';

import { ggCampaignLinksSchema } from './GGCampaignLinks';
import {
  MASTER_CAMPAIGN,
  COUNTRY,
  CURRENCY,
  AGENCY,
  INFLUENCER_CHANNEL,
  COST_MODEL,
  PAYOUT,
  GG_LINKS,
  COST_MODEL_ID,
} from './constants';

export const influencerCampaignFormValidationSchema = object({
  [MASTER_CAMPAIGN]: string().required('Master Campaign is required'),
  [COUNTRY]: string().required('Country is required'),
  [AGENCY]: string().required('Agency is required'),
  [INFLUENCER_CHANNEL]: string().required('Influencer channel is required'),
  [COST_MODEL]: object({
    [COST_MODEL_ID]: string().required('Cost model is required'),
    [CURRENCY]: string().required('Currency is required'),
    [PAYOUT]: string().required('Payout is required'),
  }),
  [GG_LINKS]: ggCampaignLinksSchema,
});
